/**
 * Projects functionality with AJAX filtering and modal
 */
(function($) {
    'use strict';

    class ProjectsManager {
        constructor() {
            this.currentPage = 1;
            this.currentCategory = 'all';
            this.isLoading = false;
            
            this.init();
        }

        init() {
            this.bindEvents();
            // Ładuj projekty tylko na stronie z siatką
            if ($('#projects-grid').length) {
                this.loadProjects();
            }
        }

        bindEvents() {
            // Kategorie
            $(document).on('click', '.category-btn', (e) => {
                e.preventDefault();
                const category = $(e.currentTarget).data('category');
                this.filterByCategory(category);
            });

            // Paginacja
            $(document).on('click', '.projects-pagination a', (e) => {
                e.preventDefault();
                const page = $(e.currentTarget).data('page');
                if (page) {
                    this.loadProjects(page, this.currentCategory);
                }
            });

            // Otwieranie modala
            $(document).on('click', '.project-item', (e) => {
                e.preventDefault();
                const projectId = $(e.currentTarget).data('project-id');
                this.openProjectModal(projectId);
            });

            // Zamykanie modala
            $(document).on('click', '.close, .modal', (e) => {
                if ($(e.target).hasClass('close') || $(e.target).hasClass('modal')) {
                    $('#project-modal').fadeOut();
                }
            });
        }

        filterByCategory(category) {
            if (this.isLoading || this.currentCategory === category) return;

            // Aktualizuj aktywny przycisk
            $('.category-btn').removeClass('active');
            $(`.category-btn[data-category="${category}"]`).addClass('active');

            this.currentCategory = category;
            this.currentPage = 1;
            this.loadProjects(1, category);
        }

        loadProjects(page = 1, category = 'all') {
            if (this.isLoading) return;

            this.isLoading = true;
            this.currentPage = page;

            $('#projects-loading').show();
            $('#projects-grid').addClass('loading');

            $.ajax({
                url: ajax_object.ajax_url,
                type: 'POST',
                data: {
                    action: 'load_projects',
                    page: page,
                    category: category,
                    nonce: ajax_object.nonce
                },
                success: (response) => {
                    if (response.success) {
                        $('#projects-grid').html(response.data.projects);
                        $('#projects-pagination').html(response.data.pagination);
                        
                        // Scroll do góry sekcji projektów po zmianie strony (ale nie przy pierwszym ładowaniu)
                        if (page > 1 || category !== 'all') {
                            $('html, body').animate({
                                scrollTop: $('#projects-grid').offset().top - 100
                            }, 500);
                        }
                    } else {
                        console.error('Błąd ładowania projektów:', response.data);
                    }
                },
                error: (xhr, status, error) => {
                    console.error('AJAX error:', error);
                },
                complete: () => {
                    this.isLoading = false;
                    $('#projects-loading').hide();
                    $('#projects-grid').removeClass('loading');
                }
            });
        }

        openProjectModal(projectId) {
            $('#modal-content-inner').html('<p>Ładowanie...</p>');
            $('#project-modal').fadeIn();

            $.ajax({
                url: ajax_object.ajax_url,
                type: 'POST',
                data: {
                    action: 'load_project_modal',
                    project_id: projectId,
                    nonce: ajax_object.nonce
                },
                success: (response) => {
                    if (response.success) {
                        $('#modal-content-inner').html(response.data.content);
                        
                        // Inicjalizuj slider w modalu jeśli są zdjęcia
                        this.initModalSlider();
                    } else {
                        $('#modal-content-inner').html('<p>Błąd ładowania projektu.</p>');
                    }
                },
                error: () => {
                    $('#modal-content-inner').html('<p>Błąd ładowania projektu.</p>');
                }
            });
        }

        initModalSlider() {
            // Sprawdź czy istnieje slider w modalu
            const modalSlider = document.querySelector('#modal-gallery-slider');
            const modalThumbs = document.querySelector('#modal-gallery-thumbs');
            
            if (modalSlider && window.Swiper) {
                let thumbsSwiper = null;
                let mainSwiper = null;
                
                // Inicjalizuj thumbnails slider jeśli istnieje
                if (modalThumbs) {
                    thumbsSwiper = new Swiper('#modal-gallery-thumbs', {
                        spaceBetween: 20,
                        slidesPerView: 2,
                        watchSlidesProgress: true,
                        slideToClickedSlide: true,
                        breakpoints: {
                            640: {
                                slidesPerView: 3,
                            },
                            768: {
                                slidesPerView: 4,
                            },
                        },
                        on: {
                            click: function(swiper, event) {
                                if (mainSwiper && swiper.clickedIndex !== undefined) {
                                    mainSwiper.slideTo(swiper.clickedIndex);
                                }
                            }
                        }
                    });
                }
                
                // Główny slider
                mainSwiper = new Swiper('#modal-gallery-slider', {
                    spaceBetween: 10,
                    navigation: {
                        nextEl: '.modal-slider-next',
                        prevEl: '.modal-slider-prev',
                    },
                    on: {
                        slideChange: function(swiper) {
                            if (thumbsSwiper) {
                                // Usuń aktywne klasy ze wszystkich thumbnails
                                thumbsSwiper.slides.forEach(slide => {
                                    slide.classList.remove('swiper-slide-thumb-active');
                                });
                                
                                // Dodaj aktywną klasę do odpowiedniego thumbnail
                                if (thumbsSwiper.slides[swiper.activeIndex]) {
                                    thumbsSwiper.slides[swiper.activeIndex].classList.add('swiper-slide-thumb-active');
                                }
                                
                                // Przewiń thumbnails do aktywnego slajdu
                                thumbsSwiper.slideTo(swiper.activeIndex);
                            }
                        },
                        init: function(swiper) {
                            // Ustaw pierwszy thumbnail jako aktywny przy inicjalizacji
                            if (thumbsSwiper && thumbsSwiper.slides[0]) {
                                thumbsSwiper.slides[0].classList.add('swiper-slide-thumb-active');
                            }
                        }
                    }
                });
            }
        }
    }

    // Inicjalizacja po załadowaniu DOM
    $(document).ready(() => {
        // Inicjalizuj zawsze - metoda init sama wykryje czy ładować listę projektów
        new ProjectsManager();
    });

})(jQuery);
